import { useTema } from "../../nucleo/tema";

/** Um botão só: o ícone mostra o tema da tela (sol no claro, lua no escuro) e o clique troca. */
export function ControleDeTema() {
  const { tema, alternarTema } = useTema();
  const acao = tema === "escuro" ? "Usar tema claro" : "Usar tema escuro";
  return (
    <button
      type="button"
      className="botao botao--fantasma botao--icone"
      aria-label={acao}
      title={acao}
      data-tema={tema}
      data-testid="alternar-tema"
      onClick={alternarTema}
    >
      {tema === "escuro" ? <Lua /> : <Sol />}
    </button>
  );
}

function Sol() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="18"
      height="18"
      aria-hidden="true"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      data-icone="sol"
    >
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
    </svg>
  );
}

function Lua() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="18"
      height="18"
      aria-hidden="true"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icone="lua"
    >
      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
    </svg>
  );
}
